import { __awaiter } from "tslib";
import { toLower } from 'lodash';
import { getEnvironment } from './getEnvFromHeader';
/** Returns the current config of the app
 *
 * @param configList A dictionary (object) of possible environments
 */
export const getAppConfig = (configList) => __awaiter(void 0, void 0, void 0, function* () {
    if (window.location.origin.includes('localhost')) {
        //Just skip the head check entirely for local dev
        return configList.dev;
    }
    const env = (yield getEnvironment()) || '';
    let defaultEnv = configList.prd;
    if (defaultEnv === null ||
        defaultEnv === undefined ||
        window.location.host.indexOf('localhost') !== -1) {
        defaultEnv = configList.dev;
    }
    const config = configList[toLower(env)] || defaultEnv;
    return config;
});
